import React from 'react';

const Footer: React.FC = () => (
  <footer className="text-center p-4 text-muted-foreground text-sm">
    © 2024 Thin Underline LLC. All rights reserved.
  </footer>
);

export default Footer;